var _path, _g, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExportExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_11)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_11",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 0H0V32H32V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_11)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 1.5C7.99187 1.5 1.5 7.99187 1.5 16C1.5 24.0081 7.99187 30.5 16 30.5C24.0081 30.5 30.5 24.0081 30.5 16C30.5 7.99187 24.0081 1.5 16 1.5ZM0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z",
    fill: "#ADB5BD"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 22.4H10.8C10.5878 22.4 10.3843 22.4843 10.2343 22.6343C10.0843 22.7843 10 22.9878 10 23.2C10 23.4122 10.0843 23.6157 10.2343 23.7657C10.3843 23.9157 10.5878 24 10.8 24H22C22.2122 24 22.4157 23.9157 22.5657 23.7657C22.7157 23.6157 22.8 23.4122 22.8 23.2C22.8 22.9878 22.7157 22.7843 22.5657 22.6343C22.4157 22.4843 22.2122 22.4 22 22.4ZM15.832 20.568C15.9081 20.6408 15.9978 20.6979 16.096 20.736C16.1918 20.7783 16.2953 20.8002 16.4 20.8002C16.5047 20.8002 16.6082 20.7783 16.704 20.736C16.8022 20.6979 16.8919 20.6408 16.968 20.568L20.168 17.368C20.3186 17.2174 20.4033 17.013 20.4033 16.8C20.4033 16.587 20.3186 16.3826 20.168 16.232C20.0174 16.0814 19.813 15.9967 19.6 15.9967C19.387 15.9967 19.1826 16.0814 19.032 16.232L17.2 18.072V8.8C17.2 8.58783 17.1157 8.38434 16.9657 8.23431C16.8157 8.08429 16.6122 8 16.4 8C16.1878 8 15.9843 8.08429 15.8343 8.23431C15.6843 8.38434 15.6 8.58783 15.6 8.8V18.072L13.768 16.232C13.6934 16.1574 13.6049 16.0982 13.5074 16.0579C13.4099 16.0175 13.3055 15.9967 13.2 15.9967C13.0945 15.9967 12.9901 16.0175 12.8926 16.0579C12.7951 16.0982 12.7066 16.1574 12.632 16.232C12.5574 16.3066 12.4982 16.3951 12.4579 16.4926C12.4175 16.5901 12.3967 16.6945 12.3967 16.8C12.3967 16.9055 12.4175 17.0099 12.4579 17.1074C12.4982 17.2049 12.5574 17.2934 12.632 17.368L15.832 20.568Z",
    fill: "#ADB5BD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_11"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportExcel);
export default __webpack_public_path__ + "static/media/exportExcel.ecbbd3ca49fa62e91c59074311b50ab5.svg";
export { ForwardRef as ReactComponent };